export default [
  {
    width: 10,
    header: {
      type: 'text',
      caption: 'Currency',
    },
    cell: {
      type: 'slot',
      name: 'currency',
    },
  },
  {
    width: 10,
    header: {
      type: 'text',
      caption: 'Blockchain fee',
    },
    cell: {
      type: 'slot',
      name: 'blockchainFee',
    },
  },
  {
    width: 10,
    header: {
      type: 'text',
      caption: 'Admin fee',
    },
    cell: {
      type: 'slot',
      name: 'adminFee',
    },
  },
];
